import React, { FunctionComponent } from 'react';
import { Grid } from '@rbx/ui';
import StandardMarkdown from '@modules/ui/markdown/components/StandardMarkdown';

import useSummaryContainerStyles from './SummaryContainer.styles';

type SummaryContainerProps = {
  description: string | null;
};

const SummaryContainer: FunctionComponent<React.PropsWithChildren<SummaryContainerProps>> = ({
  description,
}) => {
  const {
    classes: { descriptionContainer },
  } = useSummaryContainerStyles();

  return (
    <Grid container direction='column'>
      <Grid className={descriptionContainer} item>
        {description && <StandardMarkdown>{description}</StandardMarkdown>}
      </Grid>
    </Grid>
  );
};

export default SummaryContainer;
